// Sistema de Gestión Comercial: un productor que entra con su cuenta @axoncapital
// cae directo en su panel de facturación y comisión, acotado a sus clientes. El SGC
// no admite otros dominios: a un productor con Gmail no se le ofrece el enlace.
export const SGC_URL = 'https://sistema-gestion-comercial-axon.netlify.app';
